import get from 'lodash/get';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import {assetsStates} from '../../../assets/router-config';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {BreadcrumbType} from '../../../core-utilities/enums/BreadcrumbType';
import {TaskType} from '../../../tasks/enums/TaskType';
import {assetTasksStates, projectTasksStates} from '../../../tasks/router-config';
import {getAssetModel, getAssetProjectModel, getOrganizationModel, getProjectModel} from '../../model/reducers/state';
import {navStates} from '../../router';


export function buildOrganizationLink$(state$) {
  return state$
    .map(getOrganizationModel)
    .map(organization => !organization ? {} : {
      id: getId(organization),
      label: organization.name,
      type: BreadcrumbType.organization,
      to: navStates.orgsList,
    })
    .distinctUntilChanged(null, link => link.id);
}

export function buildProjectLink$(state$) {
  return state$
    .map(getProjectModel)
    .map(project => !project ? {} : {
      id: getId(project),
      label: project.name,
      type: BreadcrumbType.project,
      to: projectTasksStates.tasks,
    })
    .distinctUntilChanged(null, link => link.id);
}

export function buildAssetProjectLink$(state$) {
  return state$
    .map(getAssetProjectModel)
    .map(project => !project ? {} : {
      id: getId(project),
      label: get(project, 'shortName') || get(project, 'asset.name'),
      type: BreadcrumbType.asset,
      to: assetTasksStates.tasks,
    })
    .distinctUntilChanged(null, link => link.id);
}

export function buildAssetLink$(state$) {
  return state$
    .map(getAssetModel)
    .map(asset => !asset ? {} : {
      id: getId(asset),
      label: get(asset, 'name', get(asset, 'identifier')),
      type: BreadcrumbType.asset,
      to: assetsStates.assetsHome,
    })
    .distinctUntilChanged(null, link => link.id);
}

/**
 * @param {Observable<any>} state$
 * @param {TaskType} taskType
 * @return {Observable<Array<NavigationBreadcrumbPath>>}
 */
export function buildBreadcrumbPath$({state$, taskType}) {
  if (taskType === TaskType.ASSET) {
    return Observable
      .combineLatest(
        buildOrganizationLink$(state$),
        buildProjectLink$(state$),
        buildAssetProjectLink$(state$),
        (orgLink, projectLink, assetProjectLink) => [orgLink, projectLink, assetProjectLink]
      );
  } else {
    return Observable
      .combineLatest(
        buildOrganizationLink$(state$),
        buildProjectLink$(state$),
        (orgLink, projectLink) => [orgLink, projectLink]
      );
  }
}

export function getProjectIdFromPath(breadcrumbPath, taskType) {
  if (taskType === TaskType.ASSET) {
    return breadcrumbPath[2] ? breadcrumbPath[2].id : null;
  } else {
    return breadcrumbPath[1] ? breadcrumbPath[1].id : null;
  }
}



// WEBPACK FOOTER //
// ./src/js/app/navigation/utils/index.js